import { render, staticRenderFns } from "./ActivityCase.vue?vue&type=template&id=f306ec82&scoped=true"
var script = {}
import style0 from "./ActivityCase.vue?vue&type=style&index=0&id=f306ec82&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f306ec82",
  null
  
)

export default component.exports